
















































































































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
// import { getTranslationKeys } from '@tools/config';
import { templateVariables } from '@tools/config';
import {
  EntityTemplateVariables,
  TemplateRelatedInLoop,
  TemplateVariable,
  TemplateVariablesMap,
} from '@tools/interfaces/template';

import BpcSwitch from '@shared/components/forms/inputs/switch/switch.vue';

import BpcButtonInfo from '@shared/components/button-info.vue';

@Component({
  name: 'bpc-template-variables-help',
  components: {
    BpcButtonInfo,
    BpcSwitch,
  },
})
export default class TemplateVariablesHelpdModal extends Vue {
  @Prop({ type: String }) readonly entity: string;

  close() {
    this.$emit('click-on-close');
  }

  templateVariables: TemplateVariablesMap;
  basicFieldsCollapsed = false;
  globalFieldsCollapsed = false;
  relatedCollapsed = false;
  relatedInLoopCollapsed = false;
  showExtraInfo = false;

  beforeCreate() {
    this.templateVariables = templateVariables;
  }

  mounted() {
    this.setDefaultCollapse();
    // const translations = getTranslationKeys();
    // console.log('----------- translations ------------');
    // console.log(translations);
  }

  search = '';

  // get templateVariables(): TemplateVariablesMap {
  //   return templateVariables;
  // }

  setDefaultCollapse() {
    this.basicFieldsCollapsed = false;
    this.globalFieldsCollapsed = true;
    this.relatedCollapsed = true;
    this.relatedInLoopCollapsed = true;
  }

  expandAllCollapsed() {
    this.basicFieldsCollapsed = false;
    this.globalFieldsCollapsed = false;
    this.relatedCollapsed = false;
    this.relatedInLoopCollapsed = false;
  }

  get globalTemplateVariables(): EntityTemplateVariables {
    return this.templateVariables.global;
  }

  set globalTemplateVariables(value: EntityTemplateVariables) {
    this.templateVariables.global = value;
  }

  fieldContainsSearchText(field: TemplateVariable, normalizedSearch: string): boolean {
    return (
      this.normalizeText(field.label).includes(normalizedSearch) ||
      this.normalizeText(this.$t(field.label) as string).includes(normalizedSearch) ||
      this.normalizeText(field.contentValue).includes(normalizedSearch) ||
      this.normalizeText(field.description).includes(normalizedSearch) ||
      this.normalizeText(this.$t(field.description) as string).includes(normalizedSearch)
    );
  }

  get globalTemplateVariablesFiltered(): EntityTemplateVariables {
    if (!this.globalTemplateVariables) {
      return {
        fields: [],
        related: [],
        relatedInLoop: [],
      };
    }
    const normalizedSearch = this.normalizeText(this.search);
    const filteredFields = this.globalTemplateVariables.fields.filter(item =>
      this.fieldContainsSearchText(item, normalizedSearch),
    );

    const filteredRelated = this.globalTemplateVariables.related.map(relation => ({
      ...relation,
      fields: relation.fields.filter(item => this.fieldContainsSearchText(item, normalizedSearch)),
    }));

    const filteredRelatedInLoop = this.globalTemplateVariables.relatedInLoop.map(relation => ({
      ...relation,
      fields: relation.fields.filter(item => this.fieldContainsSearchText(item, normalizedSearch)),
    }));

    return {
      fields: filteredFields,
      related: filteredRelated,
      relatedInLoop: filteredRelatedInLoop,
    };
  }

  get currentTemplateVariablesFiltered(): EntityTemplateVariables {
    if (!this.currentTemplateVariables) {
      return {
        fields: [],
        related: [],
        relatedInLoop: [],
      };
    }
    const normalizedSearch = this.normalizeText(this.search);
    const filteredFields = this.currentTemplateVariables.fields.filter(item =>
      this.fieldContainsSearchText(item, normalizedSearch),
    );

    const filteredRelated = this.currentTemplateVariables.related.map(relation => ({
      ...relation,
      fields: relation.fields.filter(item => this.fieldContainsSearchText(item, normalizedSearch)),
    }));

    const filteredRelatedInLoop = this.currentTemplateVariables.relatedInLoop.map(relation => ({
      ...relation,
      fields: relation.fields.filter(item => this.fieldContainsSearchText(item, normalizedSearch)),
    }));

    return {
      fields: filteredFields,
      related: filteredRelated,
      relatedInLoop: filteredRelatedInLoop,
    };
  }

  get currentTemplateVariables(): EntityTemplateVariables | null {
    if (this.templateVariables && this.entity in this.templateVariables) {
      return this.templateVariables[this.entity];
    }

    return null;
  }

  set currentTemplateVariables(value: EntityTemplateVariables | null) {
    this.templateVariables[this.entity] = value;
  }

  async insertVariable(option: TemplateVariable) {
    await this.$emit('click-on-insert-variable', option);
  }
  async insertRelatedInLoop(option: TemplateRelatedInLoop) {
    await this.$emit('click-on-related-in-loop', option);
  }

  normalizeText(text: string): string {
    return text
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  }

  @Watch('search')
  onSearchChange(val) {
    if (val) {
      this.expandAllCollapsed();
    } else {
      this.setDefaultCollapse();
    }
  }
}
